import React from "react";
import { useRef } from "react";
import Hero from "./hero";
import IndustryRecognitionBenefits from "./IndustryRecognition";
import AssessmentBox from "./AboutThisNvqAssessment";
import KeyFeaturesBox from "./KeyFeaturesBox";
import WhyChooseM2HSECarousel from "./WhyM2hse";
import FAQ from "./Faqs";
import RelatedCourses from "../../../../RelatedPage/RelatedPage";
import CoursePricing from "./CoursePricing";
import EntryRequirement from "./EntryRequirements";
import HowItWorks from "./HowItsWork";
import FaqAndContact from "../../../../../Contact_Us/GetInTouch/FAQsandContactForm";
import Certification from "./Certification";

const PlasteringFibrous = () => {
  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div>
      <Hero onEnquireClick={scrollToContact} />

      <CoursePricing />
      <EntryRequirement />
      <FAQ />
      <HowItWorks />
      <AssessmentBox />
      <Certification />
      <IndustryRecognitionBenefits />
      <KeyFeaturesBox />
      <WhyChooseM2HSECarousel />
      <FaqAndContact ref={contactRef} />

      <RelatedCourses />
    </div>
  );
};

export default PlasteringFibrous;
